<app-menu-toggle
  tooltip="Object selection"
  icon="cursor"
  [active]="!hiddenSelectedInfo"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
